import { ReservationTableFiltersActionTypes, ReservationTableFiltersState, SET_RESERVATION_TABLE_FILTERS } from "store/reducers/room/reservationTableFilters/types";

const defaultState: ReservationTableFiltersState = {
  isLoading: false,
  errorMessage: "",
  contents: {},
  exists: false,
};

export default function reservationTableFilters(state = defaultState, action: ReservationTableFiltersActionTypes): ReservationTableFiltersState {
  switch (action.type) {
    case SET_RESERVATION_TABLE_FILTERS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        exists: action.exists,
      };
    default:
      return state;
  }
}
